import { Component, Input } from "@angular/core";
import { OrderStoreSelector } from "@common/selectors/order.selector";
import { CartService } from "@core/services/cart/cart.service";
import { NotificationService } from "@core/services/notification/notification.service";
import { OrdersService } from "@core/services/orders/orders.service";
import { TranslateService } from "@ngx-translate/core";
import { take, tap } from "rxjs";

@Component({
  selector: 'app-kiosk-cart-promo-code-block',
  templateUrl: './kiosk-cart-promo-code-block.component.html',
})
export class KioskCartPromoCodeBlockComponent {

  @Input() primaryButtonBackgroundColor?: string;
  @Input() primaryButtonTextColor?: string;
  @Input() secondaryButtonBackgroundColor?: string;
  @Input() secondaryButtonTextColor?: string;
  @Input() textColor?: string;
  @Input() backgroundColor?: string;

  order$ = this.orderSelector.selectValidation;

  coupons = [];

  isValidating = false;
  errorVoucher: string | undefined = undefined;
  voucher: string | undefined = undefined;

  constructor(
    private readonly orderSelector: OrderStoreSelector,
    private readonly cartService: CartService,
    private readonly ordersService: OrdersService,
    private readonly notificationService: NotificationService,
    private readonly translateService: TranslateService,
  ) {}

  applyVoucher(voucher: string | undefined): void {
    if (voucher) {
      voucher = voucher.trim();
      this.isValidating = true;
      this.cartService.addCoupon({ code: voucher });
      this.ordersService
        .checkCartIsValid$()
        .pipe(
          take(1),
          tap(order => {
            const coupon = order?.coupons?.find(el => el.code === voucher);
            if (coupon?.error) {
              this.errorVoucher = coupon.error;
              this.isValidating = false;
              this.cartService.removeCoupon({code: voucher});
              this.ordersService.checkCartIsValid$().subscribe();
              return;
            }
            this.errorVoucher = "";
            this.notificationService.displayMessage(
              this.translateService.instant('basket.notification-valid-voucher'),
            );
            this.voucher = undefined;
          }),
        )
        .subscribe();
    }
  }

  removeCoupon(coupon: any): void {
    this.cartService.removeCoupon(coupon);
    this.ordersService.checkCartIsValid$().subscribe();  
  }
 
}
